import "../../vendor/visuals/confetti.min.js";
import {
  getSuggestions,
  CONTENT_SUGGESTIONS_HTML,
  updateSuggestions,
} from "./content-suggestions.js";

$(() => {
  $("#contentCoach").html(CONTENT_SUGGESTIONS_HTML);
  if (window.location.pathname.includes("/templates")) {
    $("#closeContentCoachButton").replaceWith(`
      <div id="contentCoachNav">
        <div id="closeContentCoachNavButton" class="button button-minimal ml-3">
          <i class="fa-regular fa-xmark"></i>
          <span class="ml-2">Hide</span>
        </div>
      </div>`);
  }
});

const removeHighlighting = (editors) => {
  editors.forEach((editor) => {
    if (editor.length === 0) return;
    const body = editor.getBody();
    const highlights = body.querySelectorAll(".highlight-text");
    highlights.forEach((highlight) => {
      const parent = highlight.parentNode;
      while (highlight.firstChild) {
        parent.insertBefore(highlight.firstChild, highlight);
      }
      parent.removeChild(highlight);
    });
  });
};

const applyHighlighting = (editors, suggestions, highlightCategory) => {
  editors.forEach((editor) => {
    if (editor.length === 0) return;
    editor.formatter.register("highlight-text", {
      inline: "span",
      classes: `highlight-text`,
    });

    const highlights = suggestions.highlights || {};

    if (!highlights[highlightCategory]) return;

    highlights[highlightCategory].forEach((item) => {
      const body = editor.getBody();

      findAndReplaceDOMText(body, {
        find: "highlight-text",
        remove: true,
      });

      const escapedItem = item.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
      const pattern = `\\b${escapedItem}\\b`;

      findAndReplaceDOMText(body, {
        find: new RegExp(pattern, "gi"),
        wrap: "span",
        wrapClass: `highlight-text`,
      });
    });
  });
};

window.getContentCoach = ({ idWithStep, isTemplate = false }) => {
  $(document).off("click.coachClickEvent");
  $(document).off("mouseenter.coachClickEvent", ".suggestion.highlight");
  $(document).off("mouseleave.coachClickEvent", ".suggestion.highlight");

  const contentEditor = tinymce.get(
    `${idWithStep}${isTemplate ? "" : "-editor"}`,
  );
  const subjectEditor = isTemplate ? "" : tinymce.get(`subject-${idWithStep}`);
  const suggestionCountId = `#${idWithStep}SuggestionsCount`;
  const $suggestionCount = $(suggestionCountId);
  const options = {
    outreachType: $(`#mailType-${idWithStep}`).selectpicker("val"),
    isFollowUp: isTemplate ? false : !idWithStep.includes("outreach"),
    isSendAsReply: isTemplate
      ? false
      : $(`#sendAsReply-${idWithStep}`).is(":checked"),
    content: contentEditor ? contentEditor.getContent() : "",
    contentText: contentEditor
      ? contentEditor.getContent({ format: "text" })
      : "",
    subject: subjectEditor ? subjectEditor.getContent() : "",
    scoreSelector: suggestionCountId,

    contentCoachVisible: $("#content").hasClass("displayContentCoach"),
    notEnoughWordsCallback: () => {
      $("#content").removeClass("displayContentCoach");
      $(".suggestionCount").removeClass("opened");
    },

    post: $.wrappedPost,
  };

  window.addSpinner("#contentCoachSpinner");
  updateSuggestions(options);
  window.removeSpinner("#contentCoachSpinner");

  $(document).on(`click.coachClickEvent`, suggestionCountId, () => {
    if ($suggestionCount.hasClass("coach-disabled")) return;

    $("#content").toggleClass("displayContentCoach");
    $(".suggestionCount").addClass("opened");
    $("#content").removeClass("displayWhaleGPT");
    $("#openWhaleGPTButton").removeClass("opened");

    window.sendToHeap("Content Coach Opened");

    if (window.Intercom) {
      window.Intercom("trackEvent", "Content Coach Opened");
    }
  });

  let highlightHoverTimeout;

  $(document)
    .on("mouseenter.coachClickEvent", ".suggestion.highlight", (e) => {
      clearTimeout(highlightHoverTimeout);

      highlightHoverTimeout = setTimeout(() => {
        removeHighlighting([contentEditor, subjectEditor]);

        const highlightCategory = $(e.target)
          .closest(".suggestion.highlight")
          .data("highlight-category");
        applyHighlighting(
          [contentEditor, subjectEditor],
          getSuggestions(),
          highlightCategory,
        );
      }, 50);
    })
    .on("mouseleave.coachClickEvent", ".suggestion.highlight", (e) => {
      e.stopPropagation();
      clearTimeout(highlightHoverTimeout);
      removeHighlighting([contentEditor, subjectEditor]);
    });
};

window.addContentCoachIndicator = ({ idWithStep, isTemplate = false }) => {
  const gradientId = `${idWithStep}Gradient`;
  $(`${isTemplate ? "" : `#tab-${idWithStep} `}.tox-statusbar`)
    .append(/* html */ `
    <div id="${idWithStep}SuggestionsCount" class="suggestionCount" data-toggle="tooltip">
      <svg viewBox="0 0 36 36">
        <defs>
          <linearGradient id="${gradientId}" x1="0%" y1="0%" x2="100%" y2="0%" spreadMethod="pad">
            <stop offset="0%" stop-color="#f7797d" stop-opacity="1"></stop>
            <stop offset="50%" stop-color="#c471ed" stop-opacity="1"></stop>
            <stop offset="100%" stop-color="#049bd7" stop-opacity="1"></stop>
          </linearGradient>
        </defs>
        <circle class="bg" cx="18" cy="18" r="15.91549430918954" />
        <circle class="meter" cx="18" cy="18" r="15.91549430918954" stroke-dasharray="100 100" stroke-dashoffset="" />
      </svg>
      <span class="totalScoreNum"></span>
    </div>
  `);

  $(`#${idWithStep}SuggestionsCount .meter`).css(
    "stroke",
    `url(#${gradientId})`,
  );
};

$(document).on("click", "#closeContentCoachButton", () => {
  $("#content").removeClass("displayContentCoach");
  $(".suggestionCount").removeClass("opened");
});
